import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react'

import type { IProps, ISidebarContext } from './interfaces'

const DESKTOP_QUERY = '(min-width: 62em)'

export const SidebarContext = createContext<ISidebarContext | null>(null)

export const SidebarProvider = ({ children }: IProps): React.JSX.Element => {
  const [isMobile, setIsMobile] = useState<boolean>(() => !window.matchMedia(DESKTOP_QUERY).matches)
  const [isCollapsed, setIsCollapsed] = useState<boolean>(() => !window.matchMedia(DESKTOP_QUERY).matches)

  const setCollapsed = useCallback((collapsed: boolean): void => {
    setIsCollapsed(collapsed)
  }, [])

  const toggleSidebar = useCallback((): void => {
    setIsCollapsed((prev) => !prev)
  }, [])

  useEffect(() => {
    const mql = window.matchMedia(DESKTOP_QUERY)

    const handleChange = (event: MediaQueryListEvent): void => {
      const mobile = !event.matches
      setIsMobile(mobile)
      setIsCollapsed(mobile)
    }

    mql.addEventListener('change', handleChange)

    return (): void => {
      mql.removeEventListener('change', handleChange)
    }
  }, [])

  const contextValue = useMemo(
    (): ISidebarContext => ({ isCollapsed, isMobile, setCollapsed, toggleSidebar }),
    [isCollapsed, isMobile, setCollapsed, toggleSidebar],
  )

  return <SidebarContext value={contextValue}>{children}</SidebarContext>
}
